// AudioQuest HDMI Cables landing page
// Product data is injected server-side by sections/audioquest-hdmi-landing.liquid
// as window.aqHdmiProducts (built from real Shopify products/variants, not hardcoded).
(function () {
    function initAqHdmi(root) {
        if (!root || root.dataset.aqHdmiInit === 'true') return;
        root.dataset.aqHdmiInit = 'true';

        var products = (window.aqHdmiProducts || []).filter(function (p) { return p.productId; });

        // Union of variant length labels across all products, sorted shortest to longest.
        var lengths = [];
        products.forEach(function (p) {
            (p.variants || []).forEach(function (v) {
                if (lengths.indexOf(v.length) === -1) lengths.push(v.length);
            });
        });
        lengths.sort(function (a, b) {
            return parseFloat(a) - parseFloat(b);
        });

        var productsGrid = root.querySelector('[data-aq-products-grid]');
        var tierBtns = root.querySelectorAll('[data-aq-tier-btn]');
        var cableSelect = root.querySelector('[data-aq-cable-select]');
        var lengthSelect = root.querySelector('[data-aq-length-select]');
        var resultCable = root.querySelector('[data-aq-result-cable]');
        var resultSpecs = root.querySelector('[data-aq-result-specs]');
        var resultPrice = root.querySelector('[data-aq-result-price]');
        var buyBtn = root.querySelector('[data-aq-result-buy]');
        var buyVariantInput = root.querySelector('[data-aq-buy-variant-id]');
        var viewBtn = root.querySelector('[data-aq-result-view]');
        var faqQuestions = root.querySelectorAll('[data-aq-faq-question]');
        var modal = root.querySelector('[data-aq-modal]');
        var modalClose = root.querySelector('[data-aq-modal-close]');
        var modalHeader = root.querySelector('[data-aq-modal-header]');
        var modalBody = root.querySelector('[data-aq-modal-body]');

        var selectedCable = null;
        var selectedLength = null;

        function money(value) {
            var num = parseFloat(value);
            if (isNaN(num)) return '—';
            return '$' + num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }

        function findProduct(id) {
            return products.filter(function (p) { return p.id === id; })[0];
        }

        function findVariant(product, length) {
            if (!product) return null;
            return (product.variants || []).filter(function (v) { return v.length === length; })[0] || null;
        }

        function renderProducts(tier) {
            if (!productsGrid) return;
            var filtered = tier === 'all' ? products : products.filter(function (p) { return p.tier === tier; });

            productsGrid.innerHTML = filtered.map(function (product) {
                var firstVariant = (product.variants || [])[0];
                var startingPrice = firstVariant ? money(firstVariant.price) : '—';
                var startingLength = firstVariant ? firstVariant.length : '';
                var imageHtml = product.image
                    ? '<img src="' + product.image + '" alt="AudioQuest ' + product.name + ' HDMI Cable" loading="lazy">'
                    : '';
                var features = (product.features || []).slice(0, 4).map(function (f) {
                    return '<li>' + f + '</li>';
                }).join('');

                return (
                    '<div class="aq-product-card' + (product.featured ? ' featured' : '') + '" data-product="' + product.id + '">' +
                        '<div class="aq-product-header">' +
                            '<span class="aq-product-tier-badge aq-tier-' + product.tier + '">' + product.tierLabel + '</span>' +
                            '<div class="aq-product-image' + (imageHtml ? '' : ' no-image') + '">' + imageHtml + '</div>' +
                            '<h3 class="aq-product-name">' + product.name + '</h3>' +
                            '<div class="aq-product-specs-mini">' +
                                '<span class="aq-spec-badge highlight">' + product.bandwidth + '</span>' +
                                '<span class="aq-spec-badge">ND Level ' + product.ndLevel + '</span>' +
                                '<span class="aq-spec-badge">' + product.silver + ' Silver</span>' +
                            '</div>' +
                        '</div>' +
                        '<div class="aq-product-body">' +
                            '<ul class="aq-product-features">' + features + '</ul>' +
                            '<div class="aq-product-price">' +
                                '<div class="aq-price-from">Starting at</div>' +
                                '<div class="aq-price-value">' + startingPrice + '</div>' +
                                '<div class="aq-price-length">' + (startingLength ? 'for ' + startingLength : '') + '</div>' +
                            '</div>' +
                            '<div class="aq-product-cta">' +
                                '<button type="button" class="aq-btn aq-btn-primary" data-aq-select-cable="' + product.id + '">Select</button>' +
                                '<button type="button" class="aq-btn aq-btn-secondary" data-aq-show-details="' + product.id + '">Details</button>' +
                            '</div>' +
                        '</div>' +
                    '</div>'
                );
            }).join('');
        }

        function renderCableSelect() {
            if (!cableSelect) return;
            cableSelect.innerHTML = products.map(function (product) {
                return (
                    '<div class="aq-cable-option" data-cable="' + product.id + '">' +
                        '<div class="aq-cable-option-name">' + product.name + '</div>' +
                        '<div class="aq-cable-option-tier">' + product.tierLabel + '</div>' +
                    '</div>'
                );
            }).join('');
        }

        function renderLengthSelect() {
            if (!lengthSelect) return;
            lengthSelect.innerHTML = lengths.map(function (len) {
                return (
                    '<div class="aq-length-option" data-length="' + len + '">' +
                        '<div class="aq-length-meters">' + len + '</div>' +
                    '</div>'
                );
            }).join('');
        }

        function updateLengthAvailability() {
            if (!lengthSelect) return;
            var options = lengthSelect.querySelectorAll('.aq-length-option');
            var product = selectedCable ? findProduct(selectedCable) : null;

            options.forEach(function (opt) {
                var length = opt.dataset.length;
                if (!product) {
                    opt.classList.remove('disabled');
                    return;
                }
                if (findVariant(product, length)) {
                    opt.classList.remove('disabled');
                } else {
                    opt.classList.add('disabled');
                    if (selectedLength === length) {
                        selectedLength = null;
                        opt.classList.remove('selected');
                    }
                }
            });
        }

        function setActions(buyDisabled, buyLabel, variantId, productUrl) {
            if (buyVariantInput) buyVariantInput.value = variantId || '';
            if (buyBtn) {
                buyBtn.disabled = buyDisabled;
                buyBtn.classList.toggle('is-disabled', buyDisabled);
                buyBtn.textContent = buyLabel;
            }
            if (viewBtn) {
                var viewDisabled = !productUrl;
                viewBtn.setAttribute('href', productUrl ? (variantId ? productUrl + '?variant=' + variantId : productUrl) : '#');
                viewBtn.classList.toggle('is-disabled', viewDisabled);
                viewBtn.setAttribute('aria-disabled', viewDisabled ? 'true' : 'false');
            }
        }

        function updateCalculatorResult() {
            if (!buyBtn) return;

            if (!selectedCable || !selectedLength) {
                if (resultCable) resultCable.textContent = 'Select a cable';
                if (resultSpecs) resultSpecs.textContent = 'Choose your model and length above';
                if (resultPrice) resultPrice.textContent = '—';
                setActions(true, 'Select a Cable First', null, null);
                return;
            }

            var product = findProduct(selectedCable);
            var variant = findVariant(product, selectedLength);

            if (!product || !variant) {
                if (resultCable) resultCable.textContent = product ? product.name : 'Select a cable';
                if (resultSpecs) resultSpecs.textContent = 'This length is not available for this model';
                if (resultPrice) resultPrice.textContent = 'N/A';
                setActions(true, 'Not Available', null, product ? product.url : null);
                return;
            }

            if (resultCable) resultCable.textContent = 'AudioQuest ' + product.name;
            if (resultSpecs) resultSpecs.textContent = product.bandwidth + ' • ' + product.conductor + ' • ND Level ' + product.ndLevel + ' • ' + selectedLength;
            if (resultPrice) resultPrice.textContent = money(variant.price);

            if (variant.available === false) {
                setActions(true, 'Currently Unavailable', variant.id, product.url);
            } else {
                setActions(false, 'Add to Cart', variant.id, product.url);
            }
        }

        function selectCableInCalculator(cableId) {
            selectedCable = cableId;

            root.querySelectorAll('.aq-cable-option').forEach(function (opt) {
                opt.classList.toggle('selected', opt.dataset.cable === cableId);
            });

            updateLengthAvailability();
            updateCalculatorResult();

            var calculator = root.querySelector('[data-aq-calculator]');
            if (calculator) calculator.scrollIntoView({ behavior: 'smooth' });
        }

        function showProductDetails(productId) {
            var product = findProduct(productId);
            if (!product || !modal) return;

            if (modalHeader) {
                modalHeader.innerHTML =
                    '<h3 style="font-size: 1.8rem; margin-bottom: 0.5rem;">' + product.name + '</h3>' +
                    '<p style="color: var(--aq-text-secondary);">' + product.tierLabel + ' Series • ' + product.bandwidth + ' • ' + product.resolution + '</p>';
            }

            if (modalBody) {
                var specBox = function (label, value) {
                    return '<div class="aq-modal-spec-box"><div class="aq-modal-spec-label">' + label + '</div><div class="aq-modal-spec-value">' + value + '</div></div>';
                };

                var featuresHtml = (product.features || []).map(function (f) {
                    return '<li><span>✓</span> ' + f + '</li>';
                }).join('');

                var pricingHtml = (product.variants || []).map(function (v) {
                    return '<div class="aq-modal-price-row"><span>' + v.length + '</span><span>' + money(v.price) + '</span></div>';
                }).join('');

                modalBody.innerHTML =
                    '<div style="margin-bottom: 1.5rem;">' +
                        '<h4 style="margin-bottom: 1rem; color: var(--aq-gold);">Specifications</h4>' +
                        '<div class="aq-modal-spec-grid">' +
                            specBox('Bandwidth', product.bandwidth) +
                            specBox('Resolution', product.resolution) +
                            specBox('Conductor', product.conductor) +
                            specBox('Noise-Dissipation', 'Level ' + product.ndLevel) +
                        '</div>' +
                    '</div>' +
                    '<div style="margin-bottom: 1.5rem;">' +
                        '<h4 style="margin-bottom: 1rem; color: var(--aq-gold);">Features</h4>' +
                        '<ul class="aq-modal-feature-list">' + featuresHtml + '</ul>' +
                    '</div>' +
                    '<div>' +
                        '<h4 style="margin-bottom: 1rem; color: var(--aq-gold);">Pricing</h4>' +
                        '<div style="display: grid; gap: 0.5rem;">' + pricingHtml + '</div>' +
                    '</div>' +
                    '<div style="margin-top: 1.5rem; text-align: center;">' +
                        '<button type="button" class="aq-btn aq-btn-primary" data-aq-select-from-modal="' + product.id + '">Select This Cable</button>' +
                    '</div>';
            }

            modal.classList.add('active');
        }

        function setupEventListeners() {
            tierBtns.forEach(function (btn) {
                btn.addEventListener('click', function () {
                    tierBtns.forEach(function (b) { b.classList.remove('active'); });
                    btn.classList.add('active');
                    renderProducts(btn.dataset.aqTierBtn);
                });
            });

            root.addEventListener('click', function (e) {
                var selectBtn = e.target.closest('[data-aq-select-cable]');
                if (selectBtn) {
                    selectCableInCalculator(selectBtn.getAttribute('data-aq-select-cable'));
                    return;
                }

                var detailsBtn = e.target.closest('[data-aq-show-details]');
                if (detailsBtn) {
                    showProductDetails(detailsBtn.getAttribute('data-aq-show-details'));
                    return;
                }

                var modalSelectBtn = e.target.closest('[data-aq-select-from-modal]');
                if (modalSelectBtn) {
                    selectCableInCalculator(modalSelectBtn.getAttribute('data-aq-select-from-modal'));
                    if (modal) modal.classList.remove('active');
                    return;
                }
            });

            if (cableSelect) {
                cableSelect.addEventListener('click', function (e) {
                    var option = e.target.closest('.aq-cable-option');
                    if (!option) return;

                    root.querySelectorAll('.aq-cable-option').forEach(function (opt) { opt.classList.remove('selected'); });
                    option.classList.add('selected');
                    selectedCable = option.dataset.cable;

                    updateLengthAvailability();
                    updateCalculatorResult();
                });
            }

            if (lengthSelect) {
                lengthSelect.addEventListener('click', function (e) {
                    var option = e.target.closest('.aq-length-option');
                    if (!option || option.classList.contains('disabled')) return;

                    root.querySelectorAll('.aq-length-option').forEach(function (opt) { opt.classList.remove('selected'); });
                    option.classList.add('selected');
                    selectedLength = option.dataset.length;

                    updateCalculatorResult();
                });
            }

            faqQuestions.forEach(function (question) {
                question.addEventListener('click', function () {
                    var isActive = question.classList.contains('active');
                    var answer = question.nextElementSibling;

                    faqQuestions.forEach(function (q) {
                        q.classList.remove('active');
                        if (q.nextElementSibling) q.nextElementSibling.style.maxHeight = '0';
                    });

                    if (!isActive && answer) {
                        question.classList.add('active');
                        answer.style.maxHeight = answer.scrollHeight + 'px';
                    }
                });
            });

            if (modalClose && modal) {
                modalClose.addEventListener('click', function () {
                    modal.classList.remove('active');
                });
                modal.addEventListener('click', function (e) {
                    if (e.target === modal) modal.classList.remove('active');
                });
            }

            root.querySelectorAll('a[href^="#"]:not([data-aq-result-view])').forEach(function (anchor) {
                anchor.addEventListener('click', function (e) {
                    var href = this.getAttribute('href');
                    if (href && href.length > 1) {
                        var target = root.querySelector(href) || document.querySelector(href);
                        if (target) {
                            e.preventDefault();
                            target.scrollIntoView({ behavior: 'smooth' });
                        }
                    }
                });
            });
        }

        function setupScrollAnimations() {
            if (!('IntersectionObserver' in window)) {
                root.querySelectorAll('.aq-fade-in').forEach(function (el) { el.classList.add('visible'); });
                return;
            }
            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) entry.target.classList.add('visible');
                });
            }, { threshold: 0.1 });

            root.querySelectorAll('.aq-fade-in').forEach(function (el) { observer.observe(el); });
        }

        renderProducts('all');
        renderCableSelect();
        renderLengthSelect();
        setupEventListeners();
        setupScrollAnimations();
        updateCalculatorResult();
    }

    function initAll() {
        document.querySelectorAll('.aq-hdmi').forEach(initAqHdmi);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
    } else {
        initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
        var section = event.target.querySelector ? event.target.querySelector('.aq-hdmi') : null;
        if (section) initAqHdmi(section);
    });
})();
